import React from "react";

export default function Button({
  children,
  onClick,
  loading = false,
  disabled = false,
  variant = "", // "", secondary, blue, gold
  size = "", // "", sm
  className = "",
  type = "button",
}) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={`btn ${variant} ${size} ${loading ? "loading" : ""} ${className}`}
    >
      {loading && <span className="spinner" />}
      {children}
    </button>
  );
}
